import React from "react";
import { Button } from "components/bootstrap";
import ExternalLink from "components/common/ExternalLink";
const ExternalLinkButton = ({
  bsStyle = "default",
  target = "_blank",
  className = "",
  disabled = false,
  iconName = "open_in_new",
  children = void 0,
  ...props
}) => /* @__PURE__ */ React.createElement(Button, { bsStyle, target, className, disabled, ...props }, /* @__PURE__ */ React.createElement(ExternalLink, { iconName }, children));
export default ExternalLinkButton;
